<template>
  <div class="quote__additional">
    <div class="quote__header">
      <slot name="title">
        <div class="quote__header-top">
          <div class="quote__title">{{$t(multilangTitle)}}
          </div>
          <div class="quote__price" v-if="quoteAdditionalPrice">{{$t('qic_qar')}} {{ getFixedPrice(quoteAdditionalPrice) | splitNumber }}</div>
        </div>
      </slot>
    </div>
    <div class="quote__list">
      <div class="quote__accordion">
          <slot>
          <BaseAccordion
            v-for="(additional, index) of additionals"
            :key="index"
            :disabled="!additional.description">
            <template v-slot:name>
              {{ additional[additionalNameKey] }}
            <div class="accordion-additional" v-if="switchesShown">
              <div class="accordion-additional_price">+ {{$t('qic_qar')}} {{ getFixedPrice(additional[additionalValueKey]) | splitNumber }}</div>
                <label class="form-switch" @click.stop>
                  <input type="checkbox"  :value="additional[additionalIdKey]" v-model="selectedAdditionals_" @change="$emit('toggle', additional, $event.target.checked)">
                  <i></i>
                </label>
            </div>
            </template>
            <template v-slot:content>
              <div class="quote__content">
                {{ additional.description }}
                <div class="more-info" v-if="additional[additionalMoreInfoKey]">{{ additional[additionalMoreInfoKey].title }}: <span style="font-weight: 100;">{{ additional[additionalMoreInfoKey].info }}</span></div>
              </div>
            </template>
          </BaseAccordion>
          </slot>
      </div>
    </div>
    <div v-show="!switchesShown" style="text-align: center;">
      <a href="#" class="abcSelect__learnmore" @click.prevent="showSwitches">{{$t('qic_quote_edit_covers')}}</a>
    </div>
  </div>
</template>

<script>
import BaseAccordion from '../BaseAccordion.vue'
import { getFixed } from '../../utils/formatNumber.js'
export default {
  name: 'QuoteAdditionals',
  props: {
    additionals: { type: Array },
    selectedAdditionals: { type: Array },
    quoteAdditionalPrice: { type: Number },
    additionalNameKey: { type: String, default: 'name' },
    additionalValueKey: { type: String, default: 'value' },
    additionalIdKey: { type: String, default: 'id' },
    additionalMoreInfoKey: { type: String, default: 'moreInfo' },
    disableSwitches: { type: Boolean, default: false },
    multilangTitle: { type: String, default: 'qic_quote_additional_header' }
  },
  emits: [
    'changeSelectedAdditionals'
  ],
  components: {
    BaseAccordion
  },
  data () {
    return {
      switchesShown: true
    }
  },
  computed: {
    selectedAdditionals_: {
      get () {
        return this.selectedAdditionals
      },
      set (newValue) {
        this.$emit('changeSelectedAdditionals', { newAdditionals: newValue })
      }
    }
  },
  created () {
    this.switchesShown = !this.disableSwitches
  },
  methods: {
    showSwitches () {
      this.switchesShown = true
    },
    getFixedPrice (value) {
      return getFixed(value)
    }
  }
}
</script>

<style scoped>
  .more-info {
    font-weight: bold;
  }
</style>
